module.exports = __webpack_public_path__ + "media/steps/dowod_rejestracyjny_bcg-b42bfbb0.png";